import { render, staticRenderFns } from "./app-list.vue?vue&type=template&id=62837fbf&scoped=true&"
import script from "./app-list.js?vue&type=script&lang=js&"
export * from "./app-list.js?vue&type=script&lang=js&"
import style0 from "./app-list.scss?vue&type=style&index=0&id=62837fbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62837fbf",
  null
  
)

component.options.__file = "app-list.vue"
export default component.exports